"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personalProfileSettings = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxAct = require("redux-act");

var actions = _interopRequireWildcard(require("./personalProfileSettings.actions"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  isLoading: false,
  isLoaded: false,
  countryId: null,
  currencyId: null,
  isUnsubscribed: false,
  calendarPeriods: [],
  hideBusyCalendarPeriods: false,
  autoSendMeetingInviteToRecipient: false,
  bufferTimeInMinutes: 0,
  meetingDuration: null,
  meetingFrequency: null,
  meetingLimits: {
    startIn: null,
    finishIn: null
  },
  meetingPlace: {
    additionalInfo: '',
    place: ''
  },
  calendarTimezone: '',
  errors: {}
};
exports.initialState = initialState;
var personalProfileSettings = (0, _reduxAct.createReducer)({}, initialState).on(actions.getSettings, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: true,
    isLoaded: false
  });
}).on(actions.getSettingsSuccess, function (state, payload) {
  var countryId = payload.countryId,
      currencyId = payload.currencyId,
      isUnsubscribed = payload.isUnsubscribed,
      calendarPeriods = payload.calendarPeriods,
      hideBusyCalendarPeriods = payload.hideBusyCalendarPeriods,
      autoSendMeetingInviteToRecipient = payload.autoSendMeetingInviteToRecipient,
      bufferTimeInMinutes = payload.bufferTimeInMinutes,
      meetingDuration = payload.meetingDuration,
      meetingFrequency = payload.meetingFrequency,
      meetingLimits = payload.meetingLimits,
      meetingPlace = payload.meetingPlace,
      calendarTimezone = payload.calendarTimezone;
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    countryId,
    currencyId,
    isUnsubscribed,
    calendarPeriods,
    hideBusyCalendarPeriods,
    autoSendMeetingInviteToRecipient,
    bufferTimeInMinutes,
    meetingDuration,
    meetingFrequency,
    meetingLimits,
    meetingPlace,
    calendarTimezone
  });
}).on(actions.getSettingsFail, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: false
  });
}).on(actions.setCurrency, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: true
  });
}).on(actions.setCurrencySuccess, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    currencyId: payload
  });
}).on(actions.setCurrencyFail, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false
  });
}).on(actions.setCountry, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: true
  });
}).on(actions.setCountrySuccess, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    countryId: payload
  });
}).on(actions.setCountryFail, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false
  });
}).on(actions.unsubscribe, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: true
  });
}).on(actions.unsubscribeSuccess, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    isUnsubscribed: false
  });
}).on(actions.unsubscribeFail, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false
  });
}).on(actions.setMeetingsPreferences, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: true,
    errors: {}
  });
}).on(actions.setMeetingPreferencesSuccess, function (state, payload) {
  var hideBusyCalendarPeriods = payload.hideBusyCalendarPeriods,
      bufferTimeInMinutes = payload.bufferTimeInMinutes,
      meetingDuration = payload.meetingDuration,
      meetingFrequency = payload.meetingFrequency,
      autoSendMeetingInviteToRecipient = payload.autoSendMeetingInviteToRecipient,
      meetingPlace = payload.meetingPlace,
      calendarTimezone = payload.calendarTimezone;
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    hideBusyCalendarPeriods,
    meetingPlace,
    bufferTimeInMinutes,
    meetingDuration,
    meetingFrequency,
    autoSendMeetingInviteToRecipient,
    calendarTimezone
  });
}).on(actions.setMeetingPreferencesFail, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    errors: payload
  });
}).on(actions.setCalendarPeriod, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: true
  });
}).on(actions.setCalendarPeriodSuccess, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    calendarPeriods: payload,
    errors: {}
  });
}).on(actions.setCalendarPeriodFail, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    errors: payload
  });
});
exports.personalProfileSettings = personalProfileSettings;
[actions.setPassword, actions.resetPassword].forEach(function (action) {
  return personalProfileSettings.on(action, function (state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isLoading: true
    });
  });
});
[actions.setPasswordSuccess, actions.resetPasswordSuccess].forEach(function (action) {
  return personalProfileSettings.on(action, function (state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isLoading: false,
      errors: {}
    });
  });
});
[actions.setPasswordFail, actions.resetPasswordFail].forEach(function (action) {
  return personalProfileSettings.on(action, function (state, payload) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isLoading: false,
      errors: payload
    });
  });
});